module.exports = __webpack_public_path__ + "static/img/zxyrs.433fb631.svg";